import { Button, Space, Typography } from 'antd';
import logo from 'src/assets/logo_mintrans_light.svg';
import authService from 'src/services/authService';
import { useAppDispatch, useAppSelector } from 'src/store/store';
import { selectUserInfo, userLogoutAction } from 'src/userInfo/slice';
import { UserRole, UserRoleGroup, UserRoleName } from 'src/common/commonTypes';
import VisibilityFilter from '../components/visibilityFilter';
import AuthorizationNumberEditor from './authorizationNumberEditor';
import UserIcon from './userIcon';

const getFormattedUserRole = (role: UserRole, airlineCode: string | null) => {
    if (role === UserRole.AC) {
        return airlineCode ? `Сотрудник авиакомпании ${airlineCode}` : 'Сотрудник авиакомпании';
    }
    return UserRoleName[role];
};

function Header() {
    const dispatch = useAppDispatch();
    const userInfo = useAppSelector(selectUserInfo)!;

    const handleLogoutClick = () => {
        authService.removeData();
        dispatch(userLogoutAction());
    };

    return (
        <div className="header">
            <img className="logo" src={logo} alt="minTrans logo" />
            <Space size="large">
                <Space size="middle">
                    <VisibilityFilter role={UserRoleGroup.WithAuthNumber}>
                        <AuthorizationNumberEditor userInfo={userInfo} />
                    </VisibilityFilter>
                    <VisibilityFilter exceptRole={UserRoleGroup.WithAuthNumber}>
                        <div className="user-name-label">
                            <UserIcon />
                            <span className="user-name">{userInfo.userName}</span>
                        </div>
                    </VisibilityFilter>
                    <Typography.Text className="user-name">
                        {getFormattedUserRole(userInfo.userRole, userInfo.airlineCode)}
                    </Typography.Text>
                </Space>
                <Button className="logout-button" onClick={handleLogoutClick} type="link">
                    Выйти
                </Button>
            </Space>
        </div>
    );
}

export default Header;
